export default class ChangeProductAbstractServices {}
